import { render, staticRenderFns } from "./permision-detail.vue?vue&type=template&id=32e5f7de&scoped=true&"
import script from "./permision-detail.vue?vue&type=script&lang=ts&"
export * from "./permision-detail.vue?vue&type=script&lang=ts&"
import style0 from "./permision-detail.vue?vue&type=style&index=0&id=32e5f7de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e5f7de",
  null
  
)

export default component.exports